import PropTypes from 'prop-types';
import React, { useState } from 'react';
import { Button, Form, Modal } from 'react-bootstrap';
import { toast } from 'react-toastify';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEye, faEyeSlash } from '@fortawesome/free-solid-svg-icons';
import api from 'helpers/api';
import {
  setIdEmpresa,
  setNomeEmpresa,
  setNomeUsuario,
  setIdUsuario,
  setEmailUsuario,
  setNivelUsuario,
  setExisteImportacao,
  setExisteExportacao,
  setExisteEmbarque
} from 'helpers/auth';

const LoginForm = ({ hasLabel }) => {
  const [email, setEmail] = useState('');
  const [senha, setSenha] = useState('');
  const [errors, setErrors] = useState({ email: '', senha: '' });
  const [showPassword, setShowPassword] = useState(false);
  const [loginError, setLoginError] = useState(''); // Estado para a mensagem de erro de login
  const [showModal, setShowModal] = useState(false);
  const [emailRecuperacao, setEmailRecuperacao] = useState('');
  const [emailError, setEmailError] = useState('');
  const [successMessage, setSuccessMessage] = useState('');

  // State
  const [formData] = useState({
    email: '',
    password: '',
    remember: false
  });

  async function handleSubmit() {
    setErrors({ email: '', senha: '' });
    setLoginError(''); // Resetar a mensagem de erro de login
    let hasError = false;

    if (!email) {
      setErrors(prev => ({
        ...prev,
        email: 'O campo de e-mail é obrigatório.'
      }));
      hasError = true;
    } else if (!/\S+@\S+\.\S+/.test(email)) {
      setErrors(prev => ({
        ...prev,
        email: 'Por favor, insira um e-mail válido.'
      }));
      hasError = true;
    }

    if (!senha) {
      setErrors(prev => ({
        ...prev,
        senha: 'O campo de senha é obrigatório.'
      }));
      hasError = true;
    } else if (senha.length < 5) {
      setErrors(prev => ({
        ...prev,
        senha: 'A senha deve ter pelo menos 5 caracteres.'
      }));
      hasError = true;
    }

    if (hasError) return;

    try {      
      const res = await api.post('/api/newLogin', { email, senha });
      if (res.status === 200) {
        if (res.data.status === 1) {
          setIdUsuario(res.data.id);
          setNomeUsuario(res.data.nome);
          setEmailUsuario(res.data.email);
          setIdEmpresa(0);
          setNomeEmpresa('');
          setExisteImportacao(false);
          setExisteExportacao(false);
          setExisteEmbarque(false);
          setNivelUsuario(res.data.nivel);

          const redirectMap = {
            0: '/app/dashboard',
            1: '/CPagar',
            2: '/seguro',
            3: '/app/contacts',
            4: '/demonstrativowinning',
            5: '/demonstrativoimp',
            6: '/usuarios',
            1: '/pedidos'
          };

          window.location.href = redirectMap[res.data.nivel] || '/';
        } else {
          setLoginError('Login inválido. E-mail ou senha incorretos.'); // Mensagem de erro
        }
      } else {
        setLoginError('Erro ao se conectar ao servidor.');
      }
    } catch (error) {
      setLoginError('Erro ao se conectar ao servidor.');
    }
  }

  const togglePasswordVisibility = () => {
    setShowPassword(prevState => !prevState);
  };

  const handleCloseModal = () => {
    setShowModal(false);
    setEmailRecuperacao(''); // Limpa o campo ao fechar
    setEmailError(''); // Limpa o erro ao fechar
  };
  const handleShowModal = () => setShowModal(true);

  const handleRecoverPassword = async e => {
    e.preventDefault();
    // Validação básica do e-mail
    if (!emailRecuperacao) {
      setEmailError(prev => ({
        ...prev,
        emailRecuperacao: 'O campo de e-mail é obrigatório.'
      }));
      return;
    } else if (!/\S+@\S+\.\S+/.test(emailRecuperacao)) {
      setEmailError(prev => ({
        ...prev,
        emailRecuperacao: 'Por favor, insira um e-mail válido.'
      }));
      return;
    }
    // if (!/\S+@\S+\.\S+/.test(emailRecuperacao)) {
    //   setEmailError('Por favor, insira um e-mail válido.');
    //   return;
    // }
    try {
      // Chamada à API para recuperação de senha
      const response = await api.post('/api/recuperar-senha', {
        emailRecuperacao
      });

      // Sucesso
      setSuccessMessage(
        'E-mail de recuperação enviado com sucesso! Verifique sua caixa de entrada.'
      );
      setEmailRecuperacao(''); // Limpa o campo após o sucesso
      if (response.status === 200) {
        setTimeout(() => {
          setSuccessMessage('');
          window.location.href = '/'; // Altere para a rota correta do seu aplicativo
        }, 5000);
      }
    } catch (error) {
      // Tratar erros da API
      if (error.response && error.response.data) {
        setEmailError(
          error.response.data.message || 'Erro ao enviar o e-mail.'
        );
      } else {
        setEmailError('Erro ao enviar a solicitação.');
      }
    }
  };

  return (
    <>
      <Form>
        <Form.Group className="mb-2">
          {hasLabel && <Form.Label>E-mail</Form.Label>}
          <Form.Control
            placeholder={!hasLabel ? 'E-mail' : ''}
            value={email}
            name="email"
            onChange={e => setEmail(e.target.value)}
            type="email"
          />
          {errors.email && (
            <div className="alert alert-primary mt-1 p-1" role="alert">
              {errors.email}
            </div>
          )}
        </Form.Group>

        <Form.Group className="mb-3">
          {hasLabel && <Form.Label>Senha</Form.Label>}
          <div className="position-relative">
            <Form.Control
              placeholder={!hasLabel ? 'Senha' : ''}
              value={senha}
              name="password"
              onChange={e => setSenha(e.target.value)}
              type={showPassword ? 'text' : 'password'} // Altera o tipo com base no estado
            />
            <span
              onClick={togglePasswordVisibility}
              style={{
                cursor: 'pointer',
                position: 'absolute',
                right: '10px',
                top: '10px'
              }}
            >
              <FontAwesomeIcon icon={showPassword ? faEyeSlash : faEye} />{' '}
              {/* Ícone de olho */}
            </span>
          </div>
          {errors.senha && (
            <div className="alert alert-primary mt-1 p-1" role="alert">
              {errors.senha}
            </div>
          )}
          {loginError && (
            <div className="alert alert-primary mt-1 p-1" role="alert">
              {loginError} {/* Exibe a mensagem de erro de login */}
            </div>
          )}
        </Form.Group>

        <Button type="button" className="mt-3 w-100" onClick={handleSubmit}>
          ENTRAR
        </Button>
        {/* <div className="mt-3 text-left">
          <Button variant="link" onClick={handleShowModal}>
            Esqueceu sua senha?
          </Button>
        </div> */}
      </Form>
      {/* Modal de Recuperação de Senha */}
      <Modal show={showModal} onHide={handleCloseModal}>
        <Modal.Header closeButton>
          <Modal.Title>Recuperar Senha</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form onSubmit={handleRecoverPassword}>
            <Form.Group className="mb-3">
              <Form.Label>Digite seu E-mail</Form.Label>
              <Form.Control
                type="email"
                placeholder="E-mail"
                value={emailRecuperacao}
                onChange={e => setEmailRecuperacao(e.target.value)}
                required
              />
              {emailError && (
                <div className="alert alert-danger mt-1 p-1" role="alert">
                  {emailError}
                </div>
              )}
              {successMessage && (
                <div className="alert alert-success mt-1 p-1" role="alert">
                  {successMessage}
                </div>
              )}
            </Form.Group>
            <Button variant="primary" type="submit">
              Enviar
            </Button>
          </Form>
        </Modal.Body>
      </Modal>
    </>
  );
};

LoginForm.propTypes = {
  layout: PropTypes.string,
  hasLabel: PropTypes.bool
};

LoginForm.defaultProps = {
  layout: 'simple',
  hasLabel: false
};

export default LoginForm;
